import Vue from "vue";
import Component from "vue-class-component";
import Axios from "axios";
import Localizer from "@Scripts/Common/Localizer";
import FormHelper from "@Scripts/Common/FormHelper";

@Component({ name: "SectionList" })
export default class SectionList extends Vue {
    public localizer: any = Localizer;

    get userContext() {
        return this.$store.getters["accountUserStore/userContext"];
    }

    get sections(): any {
        return this.$store.getters["myFileSharingStore/sections"];
    }

    get markets(): any {
        return this.$store.getters["myFileSharingStore/markets"];
    }

    get routes() {
        return (<any>window).App.routes;
    }

    public goToDetail(name: string, category: any) {
        if (category) {
            this.$router.push({ name: 'SectionDetail', params: { sectionName: name }, query: { category: category } }).catch(() => { });
        } else {
            this.$router.push({ name: 'SectionDetail', params: { sectionName: name } }).catch(() => { });
        }
    }

    public editSection(sectionIdMaster: string) {
        this.$store.commit("myFileSharingStore/setSectionEditVisible", true);
        this.$store.commit("myFileSharingStore/setSectionIdMaster", sectionIdMaster);
    }

    public async deleteSection(sectionIdMaster: string) {
        if (confirm(this.localizer.get("App.FileSharing.DeleteSectionConfrim")) == true) {
            try {
                await Axios.post(this.routes.MyBremboPartsFileSharingManagement_RemoveSection, { sectionIdMaster: sectionIdMaster });

                location.reload();
            } catch (error) {
                if (error.response && error.response.status === 400) {
                    this.$store.dispatch("bremboToastStore/onAddToast", { message: FormHelper.getValidationErrors(error.response.data)[0].message, type: "Error" });
                }
            }
        }
    }

    public goToCustomSection(sectionName: string) {
        this.$router.push({ name: sectionName }).catch(() => { });
    }
}